import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import {
  Container,
  Row,
  Col,
  Card,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import React, { useState } from "react";
import imagesMetaData from '@/.sourceflow/image_metadata.json';

export default function VideoWithText({
  global,
  pathPrefix,
  pathname,
  customClass = "",
  post,
  buttonTitle,
  containerWidth=false
}) {
  return (
    post?.length >= 1 && (
      <section className={`${styles.root} ${customClass}`}>
        {post?.map((post, index) => (
          <Card
            key={index}
            className={`border-0 mb-5 pb-mb-5`}
            id={`${post.url_slug}`}
          >
            <Container className={containerWidth ? "w-100" : ""}>
              <Row className="align-items-center">
              <Col md={7} className="px-5 mb-5 mb-md-0">
                  <p className="post-title fs-4">
                    <strong>{post?.title}</strong>
                  </p>
                  {post?.short_description ? (
                    <div
                      className="post-short-description"
                      dangerouslySetInnerHTML={{
                        __html: post?.short_description,
                      }}
                    />
                  ) : null}
                  {post.button_label ? (
                    <div className="mt-4">
                      <Link href={post.button_link}>
                        <a className="primaryBtn no-arrow">
                          {post.button_label}
                        </a>
                      </Link>
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>

                {post?.video_link ? (
                  <Col className="position-relative">
                    <div className="ratio ratio-16x9">
                      <iframe
                        src={post?.video_link}
                        title="Vimeo video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </Col>
                ) : (
                  <Col md={5}>
                    <SourceFlowImage
                      src={
                        post.image
                          ? post.image
                          : "/site-assets/placeholders/img-placeholder.jpg"
                      }
                      size="800x800"
                      alt={post?.title}
                      className="card-img rounded-4"
                      imagesMetaData={imagesMetaData}
                      path={pathPrefix ? pathPrefix : `${pathPrefix}.image`}
                    />
                  </Col>
                )}
              </Row>
            </Container>
          </Card>
        ))}
      </section>
    )
  );
}
